import constants from "@blackink/core/categoryConstants";
import { Creation } from "@blackink/core/creation/util";
import { POPULAR_TAGS } from "@blackink/core/tagLists";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, Chip, IconButton, Tabs } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function CreationTagsList({
  creation,
  size = "medium",
}: {
  creation: Creation;
  size?: "small" | "medium" | "large";
}) {
  if (!creation) {
    return null;
  }

  return (
    <Box sx={{ flexGrow: 1, display: "flex" }}>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={false} // hack to prevent warning
        allowScrollButtonsMobile
        aria-label="tags"
        sx={{
          width: "100%",
          display: "grid",
          minHeight: "auto",
          // scroll bar hidden
          overflowX: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          position: "relative",
          pt: 1,
          px: 0,
          "& .MuiChip-root": {
            cursor: "pointer",
            mr: 1,
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: size === "small" ? "0.7rem" : "0.8rem",
          },
        }}
        TabIndicatorProps={{
          style: { display: "none" },
        }}
        ScrollButtonComponent={(props) => {
          const passProps = { ...props };
          delete passProps.slots;
          delete passProps.slotProps;

          return (
            <IconButton
              sx={{
                position: "absolute",
                left: props.direction === "left" ? -1 : "auto",
                right: props.direction === "right" ? -1 : "auto",
                mt: 1,
                top: "35%",
                transform: "translateY(-50%)",
                backgroundColor: "white",
                borderRadius:
                  props.direction === "left" ? "0 50% 50% 0" : "50% 0 0 50%",
                zIndex: 100,
                height: 32,
                width: 32,
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
                "&:disabled": {
                  display: "none",
                },
              }}
              // All props except slots and slotProps
              {...passProps}
            >
              {props.direction === "left" ? <ChevronLeft /> : <ChevronRight />}
            </IconButton>
          );
        }}
      >
        {creation.modifiers.map(
          (style, key) =>
            [
              constants.GENDER_DESC.men.modifier,
              constants.GENDER_DESC.women.modifier,
            ].includes(style) && (
              <Chip
                key={key}
                component={Link}
                clickable
                to={`/tattoo-ideas/${
                  constants.GENDER_DESC.men.modifier == style
                    ? constants.GENDER_DESC.men.name.toLowerCase()
                    : constants.GENDER_DESC.women.name.toLowerCase()
                }`}
                size="small"
                label={
                  constants.GENDER_DESC.men.modifier == style
                    ? constants.GENDER_DESC.men.name
                    : constants.GENDER_DESC.women.name
                }
              />
            ),
        )}

        {creation.bodyPart && !constants.GENERIC_SIZES.includes(creation.bodyPart) && (
          <Chip
            component={Link}
            clickable
            to={`/tattoo-ideas/${constants.BODY_PART_DESC[creation.bodyPart].slug}`}
            key={creation.bodyPart}
            size="small"
            label={constants.BODY_PART_DESC[creation.bodyPart].name}
          />
        )}

        {creation.prompt
          .split(" ")
          .map(
            (word, key) =>
              POPULAR_TAGS.includes(word.toLowerCase()) && (
                <Chip
                  component={Link}
                  clickable
                  key={key}
                  to={`/tattoo-ideas/${word.toLowerCase()}`}
                  size="small"
                  label={word}
                />
              ),
          )}

        {creation.style.map((style, key) =>
          constants.CATEGORY_DESC[style] ? (
            <Chip
              component={Link}
              clickable
              to={`/styles/${style}`}
              key={key}
              size="small"
              label={constants.CATEGORY_DESC[style].name}
            />
          ) : null,
        )}
      </Tabs>
    </Box>
  );
}

export default CreationTagsList;
